// components/PromotionsSection.jsx
import React from 'react';
import { Box, Grid, Typography, Paper, Link, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { FaTicketAlt, FaCalendarAlt, FaUtensils, FaStar } from 'react-icons/fa';

const promotions = [
  {
    icon: <FaTicketAlt size={40} />,
    title: 'Tuesday Discounts',
    description: 'All tickets just $10 every Tuesday. The perfect excuse for a mid-week movie night!',
    link: '/promotions/tuesday-discount'
  },
  {
    icon: <FaCalendarAlt size={40} />,
    title: 'Matinee Savings',
    description: 'Save $2 on all tickets before 4PM. Early bird gets the best seats!',
    link: '/promotions/matinee'
  },
  {
    icon: <FaUtensils size={40} />,
    title: 'Happy Hour',
    description: 'Enjoy special pricing on drinks and appetizers Mon-Thu, 4-6PM at our Cosmic Bar.',
    link: '/promotions/happy-hour'
  },
  {
    icon: <FaStar size={40} />,
    title: 'Student Discounts',
    description: 'Students save with our special $12.50 tickets. Just bring your ID!',
    link: '/promotions/student-discount'
  },
];

const PromotionsSection = () => {
  return (
    <Box sx={{ 
      py: 12, 
      bgcolor: '#050c17',
      backgroundImage: 'linear-gradient(to bottom, rgba(5, 12, 23, 0.8), rgba(10, 25, 41, 0.9))',
      boxShadow: 'inset 0 5px 10px rgba(0,0,0,0.2), inset 0 -5px 10px rgba(0,0,0,0.2)',
    }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          align="center" 
          sx={{ 
            mb: 8, 
            fontWeight: 700,
            color: 'white',
            animation: 'fadeInDown 1s ease-out',
            '@keyframes fadeInDown': {
              '0%': { opacity: 0, transform: 'translateY(-20px)' },
              '100%': { opacity: 1, transform: 'translateY(0)' }
            }
          }}
        >
          Promotions & Specials
        </Typography>
        
        <Grid container spacing={4}>
          {promotions.map((promo, index) => (
            <Grid item xs={12} sm={6} md={3} key={index} 
              sx={{ 
                animation: `fadeInUp ${0.3 + index * 0.1}s ease-out`,
                '@keyframes fadeInUp': {
                  '0%': { opacity: 0, transform: 'translateY(40px)' },
                  '100%': { opacity: 1, transform: 'translateY(0)' }
                }
              }}
            >
              <Paper 
                elevation={0}
                sx={{ 
                  p: 3, 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  bgcolor: 'background.paper',
                  transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  '&:hover': {
                    transform: 'translateY(-12px) scale(1.02)',
                    boxShadow: '0 15px 30px rgba(0,0,0,0.4)',
                    '& .promo-icon': {
                      transform: 'scale(1.2) rotate(5deg)',
                      color: 'secondary.light'
                    }
                  }
                }}
              >
                <Box 
                  className="promo-icon"
                  sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    mb: 2,
                    color: 'secondary.main',
                    transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), color 0.3s ease',
                  }}
                >
                  {promo.icon}
                </Box>
                <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600 }}>
                  {promo.title}
                </Typography>
                <Typography variant="body2" align="center" sx={{ mb: 2, flexGrow: 1 }}>
                  {promo.description}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Link 
                    component={RouterLink} 
                    to={promo.link} 
                    color="secondary"
                    underline="hover"
                    sx={{ 
                      fontWeight: 600,
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: -2,
                        left: 0,
                        width: '0%',
                        height: '2px',
                        backgroundColor: 'secondary.main',
                        transition: 'width 0.3s ease',
                      },
                      '&:hover::after': {
                        width: '100%'
                      }
                    }}
                  >
                    Learn More
                  </Link>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default PromotionsSection;